import React, { useState } from "react";
import "./Recommender.css";
import _ from "lodash";
import { useTranslation } from "react-i18next";
export default function LoanCardMidSection(props) {
  const { t } = useTranslation();

  const { partnerDetails, customer, customerDetails } = props;
  const loanCardComms = partnerDetails?.CategoryLoancard || {};

  return (
    <div className="">
      <div className="">
        
        <div className="CCCardBody">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
            Loan Amount<span style={{fontSize:10}}>(max)</span>
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {loanCardComms?.loanAmount || "-"}
            </span>
          </div>
          <div className="vline" style={{ height: "50px" }}></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
            Tenure<span style={{fontSize:10}}>(max)</span>
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {loanCardComms?.tenure || "-"}
            </span>
          </div>
        </div>
        <div className="CCCardBody">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
            Rate of interest<span style={{fontSize:10}}>(min)</span>
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {loanCardComms?.rateOfInterest || "-"}
            </span>
          </div>
          <div className="vline" style={{ height: "50px" }}></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#7E7E7E", textAlign: "center" }}>
            Processing Fee<span style={{fontSize:10}}>(min)</span>
            </span>
            <span style={{ color: "#696969", textAlign: "center" }}>
              {loanCardComms?.processingFee || "-"}
            </span>
          </div>
        </div>

        {loanCardComms?.topUSPs &&
          loanCardComms?.topUSPs.map((topUp) => {
            if (topUp.trim()) {
              return (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div>
                    <span>{`⚡`}</span>
                  </div>
                  <div>
                    <span style={{ color: "#696969" }}>{` ${topUp}`}</span>
                  </div>
                </div>
              );
            }
          })}

      </div>
    </div>
  );
}
